export default "/assets/images/wcf-v1.webp?4598a11c8cedf59c9af3e7dca1e7c461";